module.exports = __webpack_public_path__ + "img/in-work2.3e84a0c4.png";